import { Link } from "react-router-dom";
import Card from "../../card/Card";
import styles from "./PostItem.module.scss";
import { calculateAverageRating, shortenText } from "../../../utils";
import { toast } from "react-toastify";
import DOMPurify from "dompurify";
import { useDispatch } from "react-redux";

const PostItem = ({ post, grid, _id, title, image }) => {
  const dispatch = useDispatch();

  return (
    <Card cardClass={grid ? `${styles.grid}` : `${styles.list}`}>
      <Link to={`/page/${post?.slug}`}>
        <div className={styles.img}>
          <img src={image[0]} alt={title} />
        </div>
      </Link>
      <div className={styles.content}>
        <div className={styles.details}>
          <h4>{shortenText(title, 18)}</h4>
          {!grid && (
            <div
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(shortenText(post?.content, 200)),
              }}
            ></div>
          )}
        </div>
      </div>
    </Card>
  );
};
export default PostItem;
